import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

// 전체 공용코드
const allCommonCodeList =()=>{
    return customAxios.post(myIpAddress+'/commonCode/allCommonCodeList',);
}
export default allCommonCodeList;